// Store do chat da jornada — namespace `clientJourneyChat`.
//
// NOTA: o campo do streaming chama `respostaParcial`, e não "tokens": além de
// descrever melhor (é o texto acumulado até ali, não unidades de modelo), um
// identificador com `token` recebendo string literal vira Security Hotspot do
// Sonar (S2068, hard-coded credentials) e trava o quality gate.
//
// Shape deliberadamente IDÊNTICO ao do aawz-intelligence-v2/feeFixoIa
// (`messages`, `chatLoading`, `respostaParcial`, `conversationId`): é o que faz
// o componente não precisar mudar quando o stub virar SSE real.
export default {
  state: {
    messages: [],
    chatLoading: false,
    respostaParcial: '',
    conversationId: null,
    contexto: null,
    rascunho: '',
  },
  getters: {
    messages: (state) => state.messages,
    chatLoading: (state) => state.chatLoading,
    respostaParcial: (state) => state.respostaParcial,
    contexto: (state) => state.contexto,
    rascunho: (state) => state.rascunho,
    vazio: (state) => !state.messages.length && !state.respostaParcial,
  },
  mutations: {
    ADD_MESSAGE(state, message) {
      state.messages = state.messages.concat([message])
    },
    SET_LOADING(state, loading) {
      state.chatLoading = !!loading
    },
    SET_RESPOSTA_PARCIAL(state, texto) {
      state.respostaParcial = texto || ''
    },
    SET_CONTEXTO(state, contexto) {
      state.contexto = contexto || null
    },
    SET_RASCUNHO(state, texto) {
      state.rascunho = texto || ''
    },
    RESET(state) {
      state.messages = []
      state.respostaParcial = ''
      state.chatLoading = false
      state.contexto = null
      state.rascunho = ''
    },
  },
  actions: {
    adicionarMensagem({ commit }, message) {
      commit('ADD_MESSAGE', message)
    },
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    },
    setRespostaParcial({ commit }, texto) {
      commit('SET_RESPOSTA_PARCIAL', texto)
    },
    // O atalho do passo NÃO envia sozinho: prepara o composer com uma pergunta
    // editável e um chip de contexto removível. Enviar por conta própria
    // tiraria do usuário a chance de perguntar outra coisa sobre o mesmo passo.
    focarPasso({ commit }, { display, prompt, perguntaSugerida, contexto }) {
      // `prompt` é o bloco estruturado que viaja no corpo da requisição; a
      // bolha mostra só `display`. Guardar os dois aqui é o que permite o
      // componente enviar contexto rico sem poluir a conversa.
      commit('SET_CONTEXTO', { display, prompt, ...contexto })
      commit('SET_RASCUNHO', perguntaSugerida || '')
    },
    limparContexto({ commit }) {
      commit('SET_CONTEXTO', null)
      commit('SET_RASCUNHO', '')
    },
    resetar({ commit }) {
      commit('RESET')
    },
  },
}
